// src/pages/NotFound.js
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = ({ role }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <h2 style={styles.title}>Page Not Found</h2>
        <p style={styles.subtitle}>
          The page you are looking for doesn’t exist .
        </p>

        <button
          style={styles.button}
          onClick={() =>
            navigate(
              role === "Admin"
                ? "/mainlayout/dashboard"
                : "/mainlayout/creator-dashboard",
            )
          }
        >
          Go Back to Dashboard
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: "100vh",
    background: "linear-gradient(135deg, #0f0f0f, #1a1a1a)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontFamily: "Poppins, sans-serif",
  },
  card: {
    background: "#353535",
    padding: "60px 80px",
    borderRadius: "16px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
    border: "1px solid rgba(255, 153, 51, 0.2)",
  },
  code: {
    fontSize: "90px",
    margin: "0",
    color: "#b87333", // Orange accent
    letterSpacing: "5px",
  },
  title: {
    fontSize: "28px",
    margin: "10px 0",
    fontWeight: "600",
  },
  subtitle: {
    fontSize: "16px",
    color: "#aaa",
    marginBottom: "30px",
  },
  button: {
    padding: "12px 28px",
    background: "#b87333",
    border: "none",
    borderRadius: "30px",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

export default NotFound;
